<template>
  <section id="cart-discount">
    <form
      id="discount-coupon"
      method="POST"
      @submit="checkDiscountCoupon"
    >
      <input
        id="discount-coupon-input"
        type="text"
        name="name"
        :placeholder="$t('Discount code')"
      >
      <button>{{ $t('ADD') }}</button>
    </form>
  </section>
</template>
<script>
import useDiscountCoupon from './useDiscountCoupon'

export default {
  setup(props) {
    const {
      checkDiscountCoupon,
      applySpecialDiscount,
    } = useDiscountCoupon()

    applySpecialDiscount()

    return {
      checkDiscountCoupon,
    }
  },
}
</script>
